var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 10.0003H8.33301M17.4997 10.0003C17.4997 9.41699 15.838 8.32699 15.4163 7.91699M17.4997 10.0003C17.4997 10.5837 15.838 11.6737 15.4163 12.0837",
    stroke: "#6A6E85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.6876C12.4383 16.231 11.1525 17.541 9.43 17.4993C9.02917 17.4893 8.53333 17.3493 7.5425 17.0701C5.15833 16.3976 3.08833 15.2668 2.59167 12.7343C2.5 12.2701 2.5 11.746 2.5 10.6976V9.30263C2.5 8.25513 2.5 7.73097 2.59167 7.26513C3.08833 4.73347 5.15833 3.60263 7.5425 2.93013C8.53417 2.65097 9.02917 2.51097 9.43 2.50097C11.1525 2.4593 12.4383 3.7693 12.5 5.31263",
    stroke: "#6A6E85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutMenuIcon);
export default __webpack_public_path__ + "static/media/logout_menu_icon.654ce5a793526d0d4136d128ec8ef162.svg";
export { ForwardRef as ReactComponent };